<template>
    <main-content with_go_back_bar>
        <div class="bg-white p-2 shadow-sm">
            <kt-datatable ref="datatable" v-bind="datatableProps">
            </kt-datatable>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import {ApiUrl} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "@/views/wallets/DayWallets/datatable/transaction-columns";

    export default {
        components: {
            mainContent,
        },
        computed: {
            datatableProps() {
                return {
                    id: "wallet_transactions_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path(`wallet/common/transactions/${this.$route.params.hashid}`),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                }
            },
        },
    }
</script>
